import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89e109c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id", "type"]

import { reactive, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomInputField',
  props: {
  label: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    required: true,
  },
  initValue: {
    type: String,
    default: "",
  },
  inputType: {
    type: String,
    default: "text",
  },
},
  setup(__props) {

const props = __props;



const state = reactive({
  input: props.initValue,
});

const input_field = ref<HTMLInputElement | null>();

const forwardClick = () => {
  if (input_field.value) {
    input_field.value.focus(); // Focus the input element when parent div is clicked
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'input-frame',
      state.input != '' || __props.inputType == 'date' ? 'input-present' : '',
    ]),
    onClick: _withModifiers(forwardClick, ["stop"])
  }, [
    _createElementVNode("label", {
      class: "label",
      for: __props.label
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      ref_key: "input_field",
      ref: input_field,
      name: __props.label,
      id: __props.label,
      class: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.input) = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onInput', state.input))),
      type: __props.inputType
    }, null, 40, _hoisted_3), [
      [_vModelDynamic, state.input]
    ])
  ], 10, _hoisted_1))
}
}

})